import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "#F6D0E6",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D01481",
      d: "M11.656 12.318s.626-2.95-1.53-3.45c.48-.024.88-.094 1.201-.193 1.512-.46 1.64-1.722 1.67-3.142.018-.943-.047-1.851-.047-1.851-.221.028-.46.053-.706.079-.84.088-1.78.187-2.487.439-.972.343-1.61.995-1.757 2.217-.152-1.222-.785-1.874-1.757-2.217-.707-.252-1.647-.35-2.487-.44a36 36 0 0 1-.706-.078s-.065.908-.047 1.85c.03 1.415.164 2.683 1.67 3.143q.481.15 1.2.192c-2.155.5-1.528 3.451-1.528 3.451l.965-.097c1.297-.131 2.203-.223 2.684-1.963.481 1.739 1.392 1.832 2.682 1.963l.042.004z"
    }, null, -1)
  ])))
}
export default { render: render }